import { useMutation, useQueryClient } from '@tanstack/react-query';
import { converters as filesConverters } from 'store/files';
import { loaders as transmissionActsLoaders } from 'store/transmission-acts';
import { adminTransmissionActsKeys } from './admin-transmission-acts.queries';
import { loaders } from './admin-transmission-acts.loaders';
import { converters } from './admin-transmission-acts.converters';

export const useAdminUpdateTransmissionAct = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateTransmissionAct, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminTransmissionActsKeys.all);
    },
  });
};

export const useExportToXls = () => {
  return useMutation(loaders.exportXls, {
    onSuccess: filesConverters.export,
  });
};

export const useDownloadTransmissionActPdf = () => {
  return useMutation(loaders.getTransmissionAct, {
    onSuccess: async (data) => {
      const transmissionAct = converters.getTransmissionAct(data);
      const document = await transmissionActsLoaders.generateTransmissionActPdf(
        {
          transmissionAct,
        },
      );

      return filesConverters.download(
        document,
        `transmission-act-${transmissionAct.id}.pdf`,
      );
    },
  });
};
